export const sumSpecificField = (arr = [], field = '') => {
    return arr.reduce((total, curr) => total + Number(curr.value[field]), 0)
}

export const formatRateNumber = (value) => {
    return (isNaN(value) || +value === 0) ? '0.0' : (+value).toFixed(2)
}
